import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { DestinationsResponse } from '../models/destinations.model';
import { DestinationsRepository } from '../repositories/destinations.repository';

export class GetDestinationsUseCase
    implements UseCase<never, DestinationsResponse>
{
    constructor(private readonly repository: DestinationsRepository) {}

    execute(): Observable<DestinationsResponse> {
        return this.repository.getDestinations();
    }
}
